/* Collection analytics computed from real logged data.

   The prototype filled these charts with Math.random() and a hardcoded growth
   curve, because there was no history to read. There is now, so both series are
   derived from what the collector actually recorded. */

const MONTH_LABELS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** The last `count` months, oldest first, as { key: "2026-08", label: "Aug", end: Date }. */
function recentMonths(count) {
  const out = [];
  const now = new Date();
  for (let i = count - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    out.push({
      key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`,
      label: MONTH_LABELS[d.getMonth()],
      // last instant of that month, for "what did I own by then" questions
      end: new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59),
    });
  }
  return out;
}

function monthKey(dateish) {
  const d = new Date(dateish);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/** Real wear counts per month, from item_history. */
export function monthlyWears(items, count = 6) {
  const months = recentMonths(count);
  const tally = new Map(months.map((m) => [m.key, 0]));
  items.forEach((i) => {
    i.history.forEach((h) => {
      if (h.action !== "Worn") return;
      const k = monthKey(h.date);
      if (tally.has(k)) tally.set(k, tally.get(k) + 1);
    });
  });
  return months.map((m) => ({ month: m.label, flights: tally.get(m.key) }));
}

/** Wears logged in the current calendar month, across the whole collection. */
export function wearsThisMonth(items) {
  const k = monthKey(new Date());
  return items.reduce((sum, i) => sum + i.history.filter((h) => h.action === "Worn" && monthKey(h.date) === k).length, 0);
}

/** Collection value at the end of each month, using each item's acquisition date.
 *  This tracks the collection growing, not market movement — there is no price
 *  history feed, and inventing one would be a lie on a chart. */
export function valueByMonth(items, count = 6) {
  return recentMonths(count).map((m) => ({
    month: m.label,
    value: items.reduce((sum, i) => (i.dateAdded && new Date(i.dateAdded) <= m.end ? sum + i.value : sum), 0),
  }));
}

/** Percentage change between the last two points of a series, or null if undefined. */
export function trailingChangePct(series) {
  if (series.length < 2) return null;
  const prev = series[series.length - 2].value;
  const curr = series[series.length - 1].value;
  if (!prev) return null;
  return ((curr - prev) / prev) * 100;
}

export function brandBreakdown(items) {
  const map = new Map();
  items.forEach((i) => map.set(i.brand, (map.get(i.brand) || 0) + 1));
  return [...map.entries()].map(([brand, count]) => ({ brand, count }));
}
